import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  FormHelperText,
} from "@mui/material";
import "./index.scss";

const Dropdown = ({
  label,
  value = "",
  onChange,
  options = [],
  error = false,
  helperText = "",
  disabled = false,
  size = "medium",
  className = "",
  required = false,
  fullWidth = false,
  style = {}, // Add style prop
}) => {
  // Generate a unique ID for the label
  const labelId = `dropdown-label-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <FormControl
      size={size}
      className={`dropdown-control ${className}`}
      error={error}
      disabled={disabled}
      required={required}
      fullWidth={fullWidth}
      style={style} // Apply style prop
    >
      {label && (
        <InputLabel id={labelId} className="dropdown-label">
          {label}
        </InputLabel>
      )}

      <Select
        labelId={labelId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="dropdown-select"
        label={label}
        displayEmpty
        renderValue={(selected) => {
          const selectedOption = options.find(
            (option) => option.value === selected
          );
          return selectedOption ? selectedOption.label : selected;
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default Dropdown;
